// Where the actor composer sits: the AI Actors page, or Talking Head's "Add AI Actor" (live's
// `actor-generation-shell`, issue 238), which makes one portrait, ends in Cancel and "Generate AI
// Actor", and hands the actors it uploads to the form.
import { ActionIcon, Button, Group } from "@mantine/core";
import { ArrowUp } from "lucide-react";

import type { AiActor, AiActorGender } from "../../../api/generated/model";

export interface ComposerPlace {
  /** A fixed count, with no count choice: Talking Head's one (`TALKING_HEAD_ACTOR_IMAGES_COUNT`). */
  outputs?: number;
  /** Live's Cancel beside "Generate AI Actor", in place of the arrow (Talking Head's shell). */
  onCancel?: () => void;
  /** Upload Actor's most files at once: live's 3 on the page, 1 in Talking Head. */
  uploadMost?: number;
  /** The actors Upload Actor made, handed over: Talking Head puts them in its cast. */
  onCreated?: (actors: AiActor[]) => void;
  /**
   * The gender a new actor starts on: a template form's (live's template panel starts on Female,
   * `DEFAULT_ACTOR_GENDER`); none on the AI Actors page and in the Studio's Talking Head, as live's.
   */
  gender?: AiActorGender;
}

/**
 * The start at the footer's end: the page's arrow, or, in Talking Head, live's Cancel (outlined,
 * waiting while the start is on its way) and "Generate AI Actor" (`generation-actions`).
 */
export function StartActions(props: {
  place: ComposerPlace;
  canStart: boolean;
  starting: boolean;
  onStart: () => void;
}) {
  const { place, canStart, starting, onStart } = props;
  if (place.onCancel === undefined) {
    return (
      <ActionIcon
        variant="filled"
        size="lg"
        radius="100%"
        aria-label="Start"
        disabled={!canStart}
        loading={starting}
        onClick={onStart}
      >
        <ArrowUp size={20} />
      </ActionIcon>
    );
  }
  return (
    <Group gap={8} wrap="nowrap">
      <Button variant="outline" disabled={starting} onClick={place.onCancel}>
        Cancel
      </Button>
      <Button loading={starting} disabled={!canStart} onClick={onStart}>
        Generate AI Actor
      </Button>
    </Group>
  );
}
